export default "__VITE_ASSET__CyWgffTj__"